<template>
  <div>
    <li v-if="item.children && item.children.length" >
      <div class="bg" :class="{ selected: selectedId === item.id }" @click="() => recordId(item)">
        <a-icon @click.stop="isExpand = !isExpand" type="caret-down" style="width: 20px; font-size: 16px" :style="{ transform: isExpand ? 'rotate(-90deg)' : 'rotate(0deg)'}" /> {{ item.details.find(d => d.locale === 'zh-CN').name }}
      </div>
      <ul v-show="isExpand">
        <TreeNodes v-for="i in item.children" :key="i.id" :item="i" :recordId="recordId" :selectedId="selectedId" />
      </ul>
    </li>
    <li @click="() => recordId(item)" class="bg" v-else :class="{ selected: selectedId === item.id }">
      <div style="width: 20px; display: inline-block"></div>{{ item.details.find(d => d.locale === 'zh-CN').name }}
    </li>
  </div>
</template>

<script>
export default {
  name: 'TreeNodes',
  isTreeNode: true,
  props: {
    item: {
      type: Object,
      required: true
    },
    selectedId: {
      type: Number,
      required: false
    },
    recordId: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      isExpand: true
    }
  }
}
</script>

<style lang="less" scoped>
li {
  padding: 0;
  list-style: none;
  cursor: pointer;
}
.bg:hover {
  background-color: #e6f7ff;
}
.bg.selected {
  background-color: #bae7ff;
}
ul {
  margin: 0;
  padding: 0;
  padding-left: 10px;
}
</style>